import { Badge } from './ui/badge';

const statusConfig = {
  'PENDIENTE': { variant: 'secondary', className: 'bg-gray-500 text-white hover:bg-gray-600' },
  'EN EJECUCION': { variant: 'default', className: 'bg-blue-500 text-white hover:bg-blue-600' },
  'DETENIDA': { variant: 'destructive', className: 'bg-red-500 text-white hover:bg-red-600' },
  'COMPLETADA': { variant: 'default', className: 'bg-green-500 text-white hover:bg-green-600' },
  'CERRADA': { variant: 'outline', className: 'bg-slate-700 text-white hover:bg-slate-800' },
  'VIGENTE': { variant: 'default', className: 'bg-green-500 text-white hover:bg-green-600' },
  'CERRADO': { variant: 'secondary', className: 'bg-gray-500 text-white hover:bg-gray-600' },
};

export const StatusBadge = ({ status, className = '' }) => {
  const config = statusConfig[status] || statusConfig['PENDIENTE'];
  
  return (
    <Badge 
      variant={config.variant} 
      className={`${config.className} ${className} font-medium`}
      data-testid={`status-badge-${status?.toLowerCase().replace(/ /g, '-')}`}
    >
      {status}
    </Badge>
  );
};

export const StatusIndicator = ({ status, size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-3 h-3',
    lg: 'w-4 h-4',
  };

  const colorClasses = {
    'PENDIENTE': 'bg-gray-400',
    'EN EJECUCION': 'bg-blue-500',
    'DETENIDA': 'bg-red-500',
    'COMPLETADA': 'bg-green-500',
    'CERRADA': 'bg-slate-600',
    'VIGENTE': 'bg-green-500',
    'CERRADO': 'bg-gray-500',
  };

  return (
    <span 
      className={`inline-block rounded-full ${sizeClasses[size]} ${colorClasses[status] || 'bg-gray-400'}`}
      data-testid={`status-indicator-${status?.toLowerCase().replace(/ /g, '-')}`}
    />
  );
};
